import React from 'react';

import Data from './Data';

const IntroductionSidebar = (props) => {
  return <Data {...props} />;
};

export default IntroductionSidebar;
